import { VueCookies } from "vue-cookies";
import VueRouter from "vue-router";
import APIResponce from "./apiResponce";

export default class BaseAPI {
  protected cookies: VueCookies;
  protected router: VueRouter;

  constructor(vue: Vue) {
    this.cookies = vue.$cookies;
    this.router = vue.$router;
  }

  protected baseUrl(): string {
    return (
      process.env.VUE_APP_API_URL ??
      "https://llznngkc40.execute-api.us-east-1.amazonaws.com/v2"
    );
  }

  protected async request(
    input: string,
    init?: RequestInit
  ): Promise<APIResponce> {
    if (!input.endsWith("/user/login")) {
      if (!this.cookies.isKey("token")) {
        this.router.push("/login");
        return {
          code: 200,
          content: ""
        };
      }
      if (!init) {
        init = {
          headers: {
            token: this.cookies.get("token")
          }
        };
      }
      if (!init.headers) {
        init.headers = {
          token: this.cookies.get("token")
        };
      }
    }
    try {
      let response = await fetch(input, init);
      let content = await response.text();
      if (
        (response.status == 401 || response.status == 502) &&
        !response.url.endsWith("/user/login")
      ) {
        if (response.status == 401) {
          this.router.push("/login");
        }
        if (response.status == 502) {
          this.router.push("/login");
        }
      }
      return {
        code: response.status,
        content: content
      };
    } catch {
      if (!this.cookies.get("token")) {
        this.router.push("/login");
      }
    }
    return {
      code: 200,
      content: ""
    };
  }
}
